
import React from "react";
import RoomRow from "./RoomRow";

export default function RoomTypeGroup({
  group,
  collapsed,
  onToggle,
  laneCounts = {},
  ...props
}) {
  const rooms = group?.rooms || [];
  const type = group?.type || "Other";

  return (
    <section className="occ-room-group">
      <button
        type="button"
        className="occ-group-heading"
        onClick={onToggle}
        aria-expanded={!collapsed}
      >
        <span
          className={`occ-chevron ${
            collapsed ? "" : "expanded"
          }`}
        >
          ›
        </span>

        <span className="occ-group-title" title={type}>
          {type}
        </span>

        <span className="occ-group-count">
          {rooms.length}
          <span className="occ-group-count-label"> rooms</span>
        </span>
      </button>

      {!collapsed &&
        rooms.map((room, index) => {
          const roomId = String(
            room.id ??
              room.roomRowId ??
              room.roomNumber ??
              ""
          );

          return (
            <RoomRow
              key={roomId || `${type}-${index}`}
              room={room}
              laneCount={laneCounts[roomId] || 1}
              {...props}
            />
          );
        })}
    </section>
  );
}
